import { configureStore } from '@reduxjs/toolkit'
import { callApi } from './features/CallApi'
import tokenReducer from './features/tokenSlice'
import refreshTokenReducer from './features/refreshTokenSlice'
import clientTokenReducer from './features/tokenClientSlice'
import refreshClientTokenReducer from './features/refreshClientTokenSlice'
import refreshClientAuthTokenReducer from './features/refreshAuthClientTokenSlice'
import alertMsgReducer from './features/alertMsgSlisce'
import selLanguageReducer from './features/selLanguageSlice'
import tokenTPReducetr from './features/tokenTPSlice'
import whoamiTPReducetr from './features/whoamiTPSlice'
import tokenAuthenticationTPReucrder from './features/tokenAuthenticationTPSlice'
import orderTPReducetr from './features/orderTPSlice'
// import selectionReducer from './features/selectionSlice'
import { setupListeners } from '@reduxjs/toolkit/dist/query'
import { callAppApi } from './features/CallAppApi'
import { callAuthApi } from './features/CallAuthApi'
import { CallTPApi } from './features/CallTPApi'
import { callApiV2 } from './features/CallApiV2'
import basketReducer from './features/basketSlice'
import categoresSessionReducer from './features/categoresSessionSlisce'
import categoryPriceReducer from './features/categoryPriceSlisce'
import clientSliceReducer from './features/clientSlice'
import locationSchemeReducer from './features/locationSchemeSlice'
import tenantReducer from './features/tenantSlice'
import sessionReducer from './features/sessionSlice'
import sessionAssignmentsReducer from './features/sessionAssignmentsSlice'
import orderReducer from './features/orderSlice'
import orderItemsReducer from './features/orderItemsSlice'
import deleteItemsReducer from './features/deleteItemsSlice'
import sessionItemsReducer from './features/sessionItemsSlice'
import clientReducer from './features/clientSlice'
import eventReducer from './features/eventSlice'
import selectSeatOrderReducer from './features/selectSeatOrderSlice'
import selectOrderDetailsReducer from './features/selectOrderDetailsSlice'
import prePaymantsReducer from './features/prePaymantsSlice'
import selectOrderDataReducer from './features/selectOrderDataSlice'
import featureReducer from './features/featureSlice'
// Or from '@reduxjs/toolkit/query/react'

export const store = configureStore({
  reducer: {
    token: tokenReducer,
    refreshToken: refreshTokenReducer,
    clientToken: clientTokenReducer,
    clientRefreshToken: refreshClientTokenReducer,
    clientAuthTokenReducer: refreshClientAuthTokenReducer,
    alertMsg: alertMsgReducer,
    selLanguage: selLanguageReducer,
    tokenTP: tokenTPReducetr,
    whoamiTP: whoamiTPReducetr,
    tokenAuthenticationTP: tokenAuthenticationTPReucrder,
    orderTP: orderTPReducetr,
    basket: basketReducer,
    categoresSession: categoresSessionReducer,
    categoryPrice: categoryPriceReducer,
    clientSlice: clientSliceReducer,
    token: tokenReducer,
    refreshToken: refreshTokenReducer,
    locationScheme: locationSchemeReducer,
    basket: basketReducer,
    tenant: tenantReducer,
    alertMsg: alertMsgReducer,
    event: eventReducer,
    session: sessionReducer,
    categoryPrice: categoryPriceReducer,
    sessionAssignments: sessionAssignmentsReducer,
    order: orderReducer,
    orderItems: orderItemsReducer,
    deleteItems: deleteItemsReducer,
    sessionItems: sessionItemsReducer,
    client: clientReducer,
    categoresSession: categoresSessionReducer,
    selectSeatOrder: selectSeatOrderReducer,
    selectOrderDetails: selectOrderDetailsReducer,
    selectOrderData: selectOrderDataReducer,
    prePaymants: prePaymantsReducer,
    feature: featureReducer,
    // selection: selectionReducer,
    // Add the generated reducer as a specific top-level slice
    [callApi.reducerPath]: callApi.reducer,
    [callAppApi.reducerPath]: callAppApi.reducer,
    [callAuthApi.reducerPath]: callAuthApi.reducer,
    [CallTPApi.reducerPath]: CallTPApi.reducer,
    [callApiV2.reducerPath]: callApiV2.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(callApi.middleware)
      .concat(callAppApi.middleware)
      .concat(callAuthApi.middleware)
      .concat(CallTPApi.middleware)
      .concat(callApiV2.middleware),
})

setupListeners(store.dispatch)